module.exports = __webpack_public_path__ + "static/media/qrcode.1468cd3f.jpg";